import './safe-bootstrap.js';

async function ensureVendors() {
  let attempts = 0;
  while (
    typeof window.jQuery === 'undefined' &&
    typeof window.$ === 'undefined' &&
    attempts < 100
  ) {
    await new Promise((r) => setTimeout(r, 50));
    attempts++;
  }

  if (typeof window._ === 'undefined') {
    const modUnderscore = await import('underscore');
    window._ = modUnderscore.default || modUnderscore;
  }

  if (typeof window.Backbone === 'undefined') {
    const modBackbone = await import('backbone');
    window.Backbone = modBackbone.default || modBackbone;
  }

  if (
    (window.jQuery || window.$) &&
    window.Backbone &&
    window.Backbone.$ !== (window.jQuery || window.$)
  ) {
    window.Backbone.$ = window.jQuery || window.$;
  }
}

(async () => {
  await ensureVendors();
  await import('./views/views.js');
  await import('./shared.js');
  await import('./session-manager.js');
  await import('./api-helper.js');
  await import('./auth-modal.js');
  await import('./string-utils.js');
  await import('./cookie-utils.js');
  await import('./dom-utils.js');
  await import('./navigation-utils.js');
  await import('./auth-utils.js');
  await import('./api-docs.js');
})();
